<template>
  <div class="home">

    <section class="mv">
      <div class="container">
        <h2 class="title">
          <span class="bg_circleContainer"><img class="bg_circle" src="@/assets/images/mv_circle.png"></span>
          <img class="logo_icon" src="@/assets/images/mv_logo.png" alt="MAMA DAYS 総選挙">
        </h2>
        <div class="intro">
          <h3 class="subtitle"></h3>
          <p class="text">9ジャンル28部門115点の商品・サービスに<br>妊娠中・子育て中のママやパパが投票！<br>「使って良かった！」 「これからも使いたい！」<br>という生の声をぜひ参考にしてみてくださいね！</p>
        </div>
      </div>
      <p class="toScroll" v-on:click="ScrollContent">
        <picture>
          <source media="(max-width: 827px)" srcset="@/assets/images/sp/mv_scroll.png">
          <img src="@/assets/images/mv_scroll.png">
        </picture>
      </p>
    </section>

    <section class="awards_categorys">
        <h3 class="sectionTitle"><img src="@/assets/images/category_emblem.png" alt="表彰部門"></h3>
        <section class="categoryItem" v-for="(category, index) in categoryDefinition.categorys" :key="category.id" v-bind:class="category.id">
          <div class="productImage">
            <p class="number">0{{index + 1}}</p>
            <p class="product active"><img v-bind:src="'/products/'+category.id+'/'+category.departments[category.representativeIndex].id+'.png'"></p>
            <div class="horizontalBar" v-bind:style="{ backgroundColor: category.departments[category.representativeIndex].themeColor }"></div>
          </div>
          <section class="categorys">
            <p class="pageLink">ジャンル <span class="is_pc">|</span><br class="is_sp"> <router-link :to="{path:'/'+category.id}">{{ category.name }}<span class="bg"><span class="circle"></span></span></router-link></p>
            <ul class="groups" v-on:mouseover="clearRepeatingUpdateIndex()" v-on:mouseleave="leaveMenu()">
              <template v-for="(department,dindex) in category.departments" :key="department.id" >
                <router-link v-if="department.ishiddenAsDepartment !== true" :to="{path:'/'+category.id, hash:'#'+department.id}" v-on:mouseover="hoverMenu(index,dindex)">
                  <li v-if="department.forceActive !== true" v-bind:class="[category.representativeIndex == dindex ? 'active':'', department.id]">{{ department.name + "部門" }}<span class="bg"><span class="circle"></span></span></li>
                  <li v-else v-bind:class="'active'">{{ department.name + "部門" }}<span class="bg"><span class="circle"></span></span></li>
                </router-link>
              </template> 
            </ul>
          </section>
        </section>
    </section>

  </div>
</template>

<script>
import { TimelineLite } from 'gsap'
import store from '@/store/index'
import util from '@/jsUtil/util'
import jump from 'jump.js'
import lottie from 'lottie-web';
export default {
  name: 'Home',
  
  created: function () {
   //ここが一番最初に遷移してコンポーネントを作成した時(つまりurl直打ちし最初にコンポーネントされる時)の挙動になる。
  },

  data () {
    return {
      events: {},
      categoryDefinition: [],
      unsubscribe: null,
      titleAnimation: null,
      isSp: false,
    }
  },

  mounted () {
    store.commit("setOnlineShopUrl","https://bit.ly/3ndXvZW");
    this.setMetaInfo();
    //subscribeは関数として呼び出すとunsubscribeを返し、購読を中止するようになっている。
    //https://vuex.vuejs.org/api/#subscribe
    this.unsubscribe = store.subscribe((mutation, state) => {
      switch(mutation.type) {
        case "storeCategoryDefinitions":
          if (store.state.categoryDefinition != null) {
            // vuex自体が変更されてしまうのでローカルで保持
            // 逆に全部反映させたい場合はそのまま代入する
            this.categoryDefinition = JSON.parse(JSON.stringify(store.state.categoryDefinition))
          }
          break;
        case "toggleHomeAnimation":
          if( store.state.homeAnimationFlg ) {
            this.homeStartAnimation();
          }
          break;
      }
    });

    this.hiddenNavigation();

    this.scrollEvents();
    util.triggerEvent(window,"scroll");
    
    this.clearRepeatingUpdateIndex();
    this.events["startRepeatingWhenMount"] = setTimeout(()=>{ this.repeatingUpdateIndex(); },5000);
    this.generateTitleAnimation();

    if (store.state.categoryDefinition != null) {
      // vuex自体が変更されてしまうのでローカルで保持
      // 逆に全部反映させたい場合はそのまま代入する
      this.categoryDefinition = JSON.parse(JSON.stringify(store.state.categoryDefinition));
    }
   this.isSp = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  },

  // メモリリーク回避 https://jp.vuejs.org/v2/cookbook/avoiding-memory-leaks.html
	beforeRouteEnter (to, form, next) {
    const self = this;
    const resolver_anim_url = (imgurl) => {
      return new Promise((resolve,reject) => {
        const url = imgurl;
        const img = new Image();
        img.onload = () => resolve(imgurl);
        img.onerror = (e) => reject(e);
        img.src = url;
      });
    }

    const preloadProducts = async () => {
      const categorys = store.state.categoryDefinition.categorys;
      categorys.forEach( async (category,i)=>{
        const departments =  category.departments;
        departments.forEach( async (department,di)=>{
          const representImagePath = "/products/" +  category.id + "/" + department.id + ".png";
          await resolver_anim_url(representImagePath);
        });
      })
    }

    const sleep = (time) => {
      return new Promise((resolve, reject) => {
          setTimeout(() => {
              resolve();
          }, time);
      });
    }

    let handleTouchMove = (event) => {
      event.preventDefault();
    }
    
    if (!store.state.isFirstLoad) {
      next();
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      document.querySelector("body").style.overflow = "hidden";
      preloadProducts().then( async (res) => {
        await sleep(400);
        store.commit("toggleOpen");
        let tl = new TimelineLite({ onComplete: () => { 
          tl.kill();
          document.querySelector("body").style.overflow = "auto";
          document.removeEventListener('touchmove', handleTouchMove, { passive: false });
          store.commit("readyToSetFollowAnimation");
          store.commit("toggleHomeAnimation");
        }});
        tl.delay(0.8).set(".PageAnimation", { display: "none"});
      });
    } else {
      next();
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      document.querySelector("body").style.overflow = "hidden";
      store.commit("alreadyLoad");
      preloadProducts().then((res) => {
        let tl = new TimelineLite({ onComplete: () => {
          store.commit("toggleOpen");
          let innertl = new TimelineLite({ onComplete: () => {
            document.querySelector("body").style.overflow = "auto";
            document.removeEventListener('touchmove', handleTouchMove, { passive: false });
            store.commit("readyToSetFollowAnimation");
            store.commit("toggleHomeAnimation");
            innertl.kill(); 
          }});
          innertl.delay(0.8).set(".PageAnimation", { display: "none"});
          const openingEl = document.querySelector(".PageAnimation .opening");
          openingEl.parentNode.removeChild(openingEl);
          tl.kill();
        }});
        tl.delay(3.0).to(".PageAnimation .opening", 0.6, { opacity: 0});
      });
    }
  },
  
	beforeRouteLeave (to, form, next) {
    let tl = new TimelineLite({ onComplete: () => {
      store.commit("stopToSetFollowAnimation");
      store.commit("toggleInitOpen");
      setTimeout( () => { 
        store.commit("toggleInitOpen");
        store.commit("toggleOpen") 
      }, 100);
      setTimeout( () => { next(); }, 800);
      tl.kill();
      tl = null;
    }});
    tl.set(".PageAnimation",{ display: "block"});
  },

  beforeUnmount() {
    this.unsubscribe();
    this.unsubscribe = null;
    window.removeEventListener("scroll", this.events["scrollEvents"]);
    this.clearRepeatingUpdateIndex();
    if(this.events["startRepeating"]) {
      clearTimeout(this.events["startRepeating"]);
      this.events["startRepeating"] = null;
    }
    if(this.events["startRepeatingWhenMount"]) {
      clearTimeout(this.events["startRepeatingWhenMount"]);
    }
    this.titleAnimation.pause();
    lottie.destroy(this.titleAnimation.name);
    this.titleAnimation.destroy();
    this.titleAnimation = null;

    const titleCircleEl = document.querySelector(".home .mv .title");
    util.removeactive(titleCircleEl);
    const followTitleEl = document.querySelector(".follow .container .title");
    util.removeactive(followTitleEl);
    //遷移時にマウスを離したと判断され3000ms後にリピート処理が走ってしまう場合があるため
    setTimeout(()=>{
      this.clearRepeatingUpdateIndex();
      this.events["startRepeatingWhenMount"] = null;
      this.events["startRepeating"] = null;
    },3300);
  },

  methods: {
    scrollEvents() {
      const mvbgEl = document.querySelector(".bgLayer");
      const canvasEl = document.querySelector("canvas");
      const menuEl = document.querySelector(".menu");
      const flgEl = document.querySelector(".home .awards_categorys");
      const scrollEl = document.querySelector(".toScroll");
      // メインビジュアル カラー判定アニメーション
      this.events["scrollEvents"] = () => {
        const currentScroll = util.getScrollTop();
        const flgPosition = util.getoffsetTop(flgEl);
        const windowheight = window.outerHeight;
        const isSpSize = window.outerWidth < 828;
        const coef = isSpSize ? 0.3 : 0.7
        if(currentScroll + (windowheight * coef) >= flgPosition) {
          util.addactive(mvbgEl);
          util.addactive(canvasEl);
          util.addactive(menuEl,"forcePink");
          if (scrollEl.style.visibility == "visible") {
            util.addactive(scrollEl,"remove");
            setTimeout(()=> { scrollEl.style.visibility = "hidden"; },400);
          }
        } else {
          util.removeactive(mvbgEl);
          util.removeactive(canvasEl);
          util.removeactive(menuEl,"forcePink");
          if (scrollEl.style.visibility !== "visible") {
            scrollEl.style.visibility = "visible";
            setTimeout(()=> { util.removeactive(scrollEl,"remove"); },400);
          }
        }
      }
      window.addEventListener("scroll", this.events["scrollEvents"]);
    },

    homeStartAnimation() {
      const titleCircleEl = document.querySelector(".home .mv .title");
      util.addactive(titleCircleEl);
      this.titleAnimation.play();
      store.commit("toggleHomeAnimation");
    },

    generateTitleAnimation() {
      let titleEl = document.querySelector(".home .mv .subtitle");
      this.titleAnimation = lottie.loadAnimation({
        container: titleEl,
        name: "titleAnimation",
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: '/animations/title.json'
      });
    },

    setMetaInfo() {
      document.title = "MAMADAYS総選挙2020【結果発表】";
      document.querySelector("meta[name='description']").setAttribute('content', "『MAMADAYS総選挙』結果発表中！全国のママとパパの投票によって選ばれた「使ってよかった！」「これからも使い続けたい！」という商品やサービスをノミネート商品9ジャンル28部門115商品から選出。優秀賞と最優秀賞をご紹介します。");
    },

    hoverMenu(index,dindex) {
      this.clearRepeatingUpdateIndex();
      const target = this.categoryDefinition ? this.categoryDefinition.categorys[index] : null
      if(target && target.id != "expectation" && target.id != "money") {
        this.updateIndex(index,dindex);
      }
      if(this.events["startRepeatingWhenMount"]) {
        clearTimeout(this.events["startRepeatingWhenMount"]);
      }
    },

    leaveMenu() {
      if(this.events["startRepeating"]) {
        clearTimeout(this.events["startRepeating"]);
      }
      if (!this.isSp) {
        this.events["startRepeating"] = setTimeout(this.repeatingUpdateIndex,3000);
      }
    },

    updateIndex(index,dindex){
      const target = this.categoryDefinition ? this.categoryDefinition.categorys[index] : null
      if(target && target.departments.length >= 2) {
        const productImage =  document.querySelector("."+target.id+" .product");
        let timing = this.isSp ? 500 : 200;
        if(productImage) {
          util.removeactive(productImage);
          this.categoryDefinition.categorys[index].representativeIndex = dindex
          setTimeout(()=>{
            util.addactive(productImage);
          },timing);
        }
      }
    },

    repeatingUpdateIndex()  {
      this.clearRepeatingUpdateIndex();
      this.autoUpdateIndex();
      this.events["intervalUpdateIndex"] = setTimeout(this.repeatingUpdateIndex, 5000);
    },

    clearRepeatingUpdateIndex()  {
      if(this.events["startRepeating"]) {
        clearTimeout(this.events["startRepeating"]);
      }
      if(this.events["intervalUpdateIndex"]) {
        clearTimeout(this.events["intervalUpdateIndex"]);
      }
    },

    autoUpdateIndex(){
      const categoryDefinition = this.categoryDefinition.categorys;
      categoryDefinition.forEach((category,i) =>  {
        const departmentsLength  = category.departments.length;
        const representativeIndex = (category.representativeIndex + 1) % departmentsLength;
        this.updateIndex(i,representativeIndex);
      })
    },

    hiddenNavigation() {
      const menuEl = document.querySelector(".menu");
      const navEl = document.querySelector("#navigation");
      const elbody = document.querySelector("body");
      if(menuEl.classList.contains("active")) {
          elbody.style.overflow = "visible";
          util.addactive(navEl, "deactive");
          util.removeactive(menuEl);
          util.removeactive(navEl);
          setTimeout(()=>{
            navEl.style.display = "none";
          },800);
      }
    },

    ScrollContent(){
      const targetEl = document.querySelector(".home .breastfeeding");
      jump(targetEl, { duration: 200, offset: -100});
    }
  }
}
</script>

<style lang="scss">
.home {
  .mv {
    box-sizing: border-box;
    position: relative;
    width: 100vw;
    height: 100vh;
    margin-bottom: percent_resize(223,1920);
    .container {
      position: relative;
      top: 51%;
      transform: translate(0,-50%);
      width: percent_resize(1250,1920);
      max-width: 980px;
      min-width: 783px;
      margin: 0 auto;
      .title {
        position: absolute;
        width: percent_resize(600,1250);
        left: -10%;
        top: 0%;
        transform: translate(0,-50%);
        &.active {
          .bg_circleContainer {
            transform: scale(1);
          }
          .logo_icon {
            transform: translate(-50%,-50%) scale(1);
          }
        }
        .bg_circleContainer {
          display: block;
          transform: scale(0);
          @include transition_anim($delay-time: 0.4s,$duration-time: 0.7s, $propertys: (transform));
          transition-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
          &:before {
            @include content_pseudo;
            left: -15%;
            top: -10%;
            width: 128%;
            padding-top: 128%;
            z-index: 0;
            background-image: url("~@/assets/images/logo_shadow.png");
            background-size: 100% auto;
            will-change: transfrom;
            @keyframes rotate_str_shadow {
              0% { 
                transform: rotate(0deg);
              }
              100% {
                transform: rotate(360deg);
              }
            }
            @include animationProp(rotate_str_shadow, 35.0s, 0.0s, linear);
            animation-iteration-count: infinite;
          }
        }
        .bg_circle {
          position: relative;
          width: 100%;
          transform-origin: center;
          z-index: 500;
          will-change: transfrom;
          @keyframes rotate_str {
            0% { 
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
          @include animationProp(rotate_str, 35.0s, 0.0s, linear);
          animation-iteration-count: infinite;
        }
        .logo_icon {
          position: absolute;
          width: percent_resize(460,600);
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%) scale(0);
          z-index: 1000;
          will-change: transform;
          @include transition_anim($duration-time: 0.7s, $propertys: (transform));
          transition-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
        }
      }
      .intro {
        width: percent_resize(700,1250);
        position: absolute;
        right: 0%;
        transform: translate(0,-57%);
        .subtitle {
          position: relative;
          width: 100%;
          padding-top: 59%;
          height: auto;
          svg {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        .text {
          @include font_style_pc;
          font-size: 17px;
          margin-top: 4%;
          font-weight: 500;
          white-space: nowrap;
          color: $color-white;
          text-align: center;
        }
      }
    }
    .toScroll {
      position: fixed;
      width: displaysize(45);
      left: 4%;
      bottom: 4%;
      backface-visibility: hidden;
      @include hoverlink;
      &.remove {
        opacity: 0;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }

  .awards_categorys {
    margin-bottom: displaysize(427); 
    .sectionTitle {
      margin: 0 auto percent_resize(128,1920);
      width: displaysize(180);
    }
    .categoryItem {
      width: percent_resize(1650,1920);
      margin-bottom: percent_resize(220,1920);
      &.homeappliances, &.toilet, &.money,  &.care{
        margin-bottom: 15%;
      }
      .productImage {
        position: absolute;
        width: percent_resize(1067,1650);
        left: -7%;
        top: 50%;
        transform: translate(0,-52%);
        .horizontalBar {
          border-radius: 200px;
          height: displaysize(107);
          width: 100%;
          will-change: background-color;
          @include transition_anim($duration-time: 1.0s, $propertys: (background-color));
        }
        .number {
          position: absolute;
          display: inline-block;
          font-size: displaysize(40);
          font-weight: bold;
          top: 50%;
          right: calc(53% + #{displaysize(50)});
          transform: translate(0,-54%);
          z-index: 2000;
          color: #ffffff;
        } 
        .product {
          position: absolute;
          width: percent_resize(350,1067);
          top: 30%;
          right: 11%;
          transform: translate(0,-50%);
          z-index: 2000;
          &.active {
            img {
              @include transition_anim($duration-time: 1.0s);
              transform: translate(0,0);
              opacity: 1;
            }
          }
          img {
            will-change: transform,opacity;
            transform: translate(0,40px);
            opacity: 0;
          }
        }
      }
      .categorys {
        width: percent_resize(550,1650);
        float: right;
        .pageLink {
          font-size: displaysize(25);
          margin-bottom: percent_resize(43,630);
          font-family: 'M PLUS Rounded 1c', sans-serif;
          .is_pc {
            display: inline;
          }
          a {
            opacity: 1.0;
            will-change: color;
            &:hover {
              .bg {
                .circle {
                  background-color: $fontPink;
                  width: 160%;
                  padding-top: 160%;
                  height: auto;
                  top: -32%;
                  left: -29%;
                }
                &:after {
                  opacity: 0.0; 
                }
                &:before { 
                  opacity: 1.0; 
                }
              }
            }
            .bg {
              display: block;
              position: absolute;
              width: displaysize(30);
              padding-top: displaysize(30);
              right: -28px;
              top: 50%;
              transform: translate(0,-50%);
              .circle {
                display: block;
                position: absolute;
                width: 100%;
                padding-top: 100%;
                border-radius: 50%;
                border: 1px solid $fontPink;
                left: 0;
                top: 0;
                z-index: 0;
                will-change: background-color,padding-top,width;
                background-color: transparent;
                @include transition_anim($duration-time: 0.8s, $propertys: (background-color,width,padding-top,left,top));
                backface-visibility: hidden;
              }
              &:after {
                @include content_pseudo;
                width: 56%;
                height: 56%;
                background-size: 100% auto;
                left: 56%;
                top: 54%;
                transform: translate(-50%,-50%);
                z-index: 100;
                background-image: url("~@/assets/images/icon_arrow_pink.png");
                background-repeat: no-repeat;
                background-size: 100% auto;
                will-change: opacity;
                @include transition_anim($duration-time: 1.0s, $propertys: (opacity));
              }
              &:before {
                @include content_pseudo;
                width: 56%;
                height: 56%;
                background-size: 100% auto;
                left: 56%;
                top: 54%;
                transform: translate(-50%,-50%);
                background-image: url("~@/assets/images/icon_arrow_pink_hover.png");
                background-repeat: no-repeat;
                background-size: 100% auto;
                z-index: 200;
                opacity: 0;
                will-change: opacity;
                @include transition_anim($duration-time: 1.0s, $propertys: (opacity));
              }
            }
          }
        }
        .groups {
          li {
            position: relative;
            padding: percent_resize(30,630) 0 percent_resize(30,630) 0;
            font-size: displaysize(26);
            letter-spacing: 0.01em;
            font-family: 'M PLUS Rounded 1c', sans-serif;
            &:hover {
              border-top: 1px solid #CCCCCC;
              border-bottom: 1px solid #CCCCCC;
            }
            .bg {
              display: block;
              position: absolute;
              width: percent_resize(40,630);
              padding-top: percent_resize(40,630);
              right: 4%;
              top: 50%;
              transform: translate(0,-50%);
              .circle {
                display: block;
                position: absolute;
                width: 100%;
                padding-top: 100%;
                border-radius: 50%;
                border: 1px solid $fontPink;
                left: 0;
                top: 0;
                z-index: 0;
                will-change: background-color,width,padding-top,left,top;
                background-color: transparent;
                @include transition_anim($duration-time: 0.8s, $propertys: (background-color,width,padding-top,left,top));
                backface-visibility: hidden;
              }
              &:after {
                @include content_pseudo;
                width: 56%;
                height: 56%;
                background-size: 100% auto;
                left: 55%;
                top: 52%;
                transform: translate(-50%,-50%);
                z-index: 100;
                background-image: url("~@/assets/images/icon_arrow_pink.png");
                background-repeat: no-repeat;
                background-size: 100% auto;
                will-change: opacity;
                @include transition_anim($duration-time: 1.0s, $propertys: (opacity));
              }
              &:before {
                @include content_pseudo;
                width: 56%;
                height: 56%;
                background-size: 100% auto;
                left: 55%;
                top: 52%;
                transform: translate(-50%,-50%);
                background-image: url("~@/assets/images/icon_arrow_pink_hover.png");
                background-repeat: no-repeat;
                background-size: 100% auto;
                z-index: 200;
                opacity: 0;
                will-change: opacity;
                @include transition_anim($duration-time: 1.0s, $propertys: (opacity));
              }
            }
            &.active {
              .bg {
                .circle {
                  background-color: $fontPink;
                  width: 160%;
                  padding-top: 160%;
                  height: auto;
                  top: -32%;
                  left: -29%;
                }
                &:after {
                  opacity: 0.0; 
                }
                &:before { 
                  opacity: 1.0; 
                }
              }
              border-top: 1px solid #000000!important;
              border-bottom: 1px solid #000000!important;
              z-index: 1000!important;
            }
          }
        }
      }
    }
  }
}
@import "./scss/home_sp.scss";
</style>
